export default {
  SET_MASTER_ITEMS(state, items) {
    state.masterItems = items;
  },
  SET_DASHBOARD_DATA(state, data) {
    state.dashboardData = data;
  },
  SET_REPORT_DATA(state, rows) {
    state.reportData = rows;
  },
};
